import { render, staticRenderFns } from "./Carrello2.vue?vue&type=template&id=40e5b3a7&scoped=true&"
import script from "./Carrello2.vue?vue&type=script&lang=js&"
export * from "./Carrello2.vue?vue&type=script&lang=js&"
import style0 from "./Carrello2.vue?vue&type=style&index=0&id=40e5b3a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e5b3a7",
  null
  
)

export default component.exports